RA.MostHelpfulSolutions = {
  init(options) {
    let defaultOptions = {
      timeRange: "lastweek"
    };
    options = $.extend({}, defaultOptions, options);

    let url = `${Config.contextPath}/app/portlets/popularitems/worker.jsp`;
    let data = {
      items: "effectiveViews",
      timerange: options.timeRange
    };

    $.get(url, data)
      .done(r => this.render(r.effectiveViews));
  },
  renderNoContent() {
    return <NoContent message={Labels.getLabel("No solutions found")} center={false} />;
  },
  renderList(data) {
	let slParam = simplifiedSocialLayoutParam;
	let linkParam = launchLinksInNewWindowParam;

	let target = "";
	if (launchLinksInNewWindow) {
		target = `_blank`;
	} else {
		target = `_self`;
	}

    let items = data.map(sol => {
      return (
        <li key={sol.id}>
          <a target={target} href={`${Config.contextPath}/app/portlets/results/viewsolution.jsp?solutionid=${sol.id}${slParam}${linkParam}`}>{sol.title}</a>
        </li>
      );
    });

    return (
      <ul className="bullet-list">
        {items}
      </ul>
    )
  },
  render(data) {
    let content = data.length > 0 ?
      this.renderList(data) : this.renderNoContent();

    ReactDOM.render(content, document.getElementById("mostHelpful"));
  }
}